import { render } from "./TabsAnimatedHeader.vue?vue&type=template&id=89d5a6a2"
import script from "./TabsAnimatedHeader.ts?vue&type=script&lang=js&external"
export * from "./TabsAnimatedHeader.ts?vue&type=script&lang=js&external"

import "./TabsAnimatedHeader.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__